import { BASE_URL } from "./Constants";

export const GET_DOCTOR_LIST = `${BASE_URL}api/Doctor/GetVisibleDoctors`;
